import React from 'react';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();
  
  return (
    <footer className="bg-bmb-accent border-t border-bmb-border mt-auto">
      <div className="container mx-auto px-4 py-4">
        <div className="text-center">
          <p className="text-sm text-gray-600">
            {t('footer.copyright', { year: new Date().getFullYear() })}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;